export const dialogTheme = {
  extend: {
    header: {
      padding: "0.45rem 0.75rem",
    },
    custom: {
      border: "none",
      headerTitleBackground: "{primary.color}",
      headerTitleColor: "{primary.contrast.color}",
      headerTitleFontSize: "1.5rem",
      headerTitleFontWeight: "bold",
      headerBorder: "1px solid {primary.color}",
    },
  },
  css: ({ dt }: { dt: (token: string) => string }) => `
    .p-dialog {
      border: ${dt("dialog.custom.border")};
    }
    .p-dialog .p-dialog-title,
    .p-dialog .p-dialog-header {
      background: ${dt("dialog.custom.headerTitleBackground")};
      color: ${dt("dialog.custom.headerTitleColor")};
      font-size: ${dt("dialog.custom.headerTitleFontSize")};
      font-weight: ${dt("dialog.custom.headerTitleFontWeight")};
    }
    .p-dialog .p-dialog-header {
      border: ${dt("dialog.custom.headerBorder")};
      border-top-left-radius: ${dt("dialog.root.borderRadius")};
      border-top-right-radius: ${dt("dialog.root.borderRadius")};
    }
    .p-dialog .p-dialog-header-actions .p-button{
      color: ${dt("surface.0")};
    }
  `,
};